import React, { useState } from 'react';
import {
  BreadCrumbs,
  Container,
  PostSection,
  PostSidebar,
  Notification,
} from '../../components';
import { IPostPageProps } from './blog.types';
import PostPageIntro from './post-page-intro';
import styles from './post-page.module.css';

export default function PostPage({ post }: IPostPageProps) {
  const [activeIndex, setActiveIndex] = useState(1);

  return (
    <>
      <PostPageIntro
        title={post.article.title}
        background={post.article.background}
        time={post.article.time}
        date={post.article.date}
        authorAvatar={post.article.author_photo}
        authorName={post.article.author_name}
        authorPosition={post.article.author_position}
      />
      <article className={styles.post}>
        <Container className={styles.post_container}>
          <div className={styles.post__crumbs}>
            <BreadCrumbs
              crumbs={[
                {
                  id: 1,
                  name: 'Mavinx',
                  path: '/',
                },
                {
                  id: 2,
                  name: 'Blog',
                  path: '/blog',
                },
                {
                  id: 3,
                  name: post.article.title,
                  path: '#',
                },
              ]}
            />
          </div>
          <div className={styles.post__body}>
            <div className={styles.sidebar}>
              <PostSidebar active={activeIndex} list={post.article.subtitles} />
            </div>
            <div className={styles.content}>
              {post.article.subtitles.map((item, index) => (
                <PostSection
                  key={item.id}
                  setIndex={setActiveIndex}
                  index={index}
                  {...item}
                />
              ))}
            </div>
          </div>

          <Notification
            title="HAVE A PROJECT IN MIND?"
            buttonName="Contact us"
            href="/contact"
            className={styles.notification}
          />
        </Container>
      </article>
    </>
  );
}
